import { throwNotComplexObject, throwNotType } from '@esm-test/guards';

const defaultParserFlags = {
  allowLiteralOnly: true,
  allowLiteralTitle: true,
  allowLiteralCases: true
};

/**
 * Flags to enable or disable specific parser behaviors for identifying test metadata.
 */
export class TestParserFlags {
  /**
   * Whether to allow 'only' to be specified as a literal property (e.g., `test.only = true`).
   */
  allowLiteralOnly: boolean = true;

  /**
   * Whether to allow 'title' to be specified as a literal property (e.g., `test.title = '...'`).
   */
  allowLiteralTitle: boolean = true;

  /**
   * Whether to allow 'cases' to be specified as a literal property (e.g., `test.cases = [...]`).
   */
  allowLiteralCases: boolean = true;

  /**
   * Initializes a new TestParserFlags instance.
   * @param parserFlags - Partial flags to override defaults.
   */
  constructor (parserFlags: Partial<TestParserFlags> | any) {
    throwNotComplexObject("parserFlags", parserFlags)

    Object.assign(this, defaultParserFlags, parserFlags);

    throwNotType("allowLiteralOnly", this.allowLiteralOnly, "boolean");
    throwNotType("allowLiteralTitle", this.allowLiteralTitle, "boolean");
    throwNotType("allowLiteralCases", this.allowLiteralCases, "boolean");
  }

}
